import { MenuItem } from "primeng/api";

export const ChargeItemDocumentType = {
  Factura: "Factura",
  Boleta: "Boleta",
  OC: "OC",
  Referencia: "Referencia",
} as const;

export type ChargeItemDocumentType = (typeof ChargeItemDocumentType)[keyof typeof ChargeItemDocumentType];

export interface ChargeItem {
  documentType: ChargeItemDocumentType;
  documentNumber: string;
  description: string;
  amount: number;
}

export enum ChargeStatus {
  PAGADO = "Pagado",
  ANULADO = "Anulado",
  PENDIENTE = "Pendiente",
  NOPAGADO = "No Pagado",
}

export interface Charge {
  id: string;
  date: Date;
  amount: number;
  type: string;
  status: ChargeStatus;
  order_number: string;
  merchant_id: string;
  status_reason: string;
  payment_link_url: string;
  payment_intent_id: string;
  items: ChargeItem[];
  menuItems?: MenuItem[]; //menu de cobro, en el listado
}

export interface ChargeFormData {
  items: ChargeItem[];
  total: number;
}
